var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 5 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-5-Copy",
    stroke: "#80959D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    cx: 14.5,
    cy: 4.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50965371,5.13761948 L10.0356355,0.673207265 C10.4098903,0.304043728 10.9144427,0.0970725069 11.4401311,0.0970725069 L17.8479924,0.0970725069 C18.4002772,0.0970725069 18.8479924,0.544787757 18.8479924,1.09707251 L18.8479924,7.56560421 C18.8479924,8.09615078 18.6371887,8.60495796 18.2619742,8.98004955 L10.4951119,16.7443661 C9.71967128,17.5195526 8.46466515,17.5258701 7.68145976,16.7585295 L2.13560058,11.3250085 C1.34660181,10.5519919 1.33364572,9.28572818 2.10666235,8.49672941 C2.11449099,8.48873892 2.12238652,8.48081425 2.13034812,8.47295623 L5.50965371,5.13761948 Z",
    id: "Path-2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/Tag-icon.9d8b60b12eff293064648bf76e03abe1.svg";
export { ForwardRef as ReactComponent };